import { render, staticRenderFns } from "./ChartWidgetCaseSituation.vue?vue&type=template&id=93fe455a&scoped=true&"
import script from "./ChartWidgetCaseSituation.vue?vue&type=script&lang=js&"
export * from "./ChartWidgetCaseSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fe455a",
  null
  
)

export default component.exports